import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-tekst-voorheffingen-buitenlBronbel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-voorheffingen-buitenlBronbel.component.html',
  styleUrl: './tekst-voorheffingen-buitenlBronbel.component.scss',
})
export class TekstVoorheffingenBuitenlBronbelComponent {}
